import routes from '@/modules/closure/routes'
import store from '@/modules/closure/store'

export default { routes, store }
